<mat-card class="card-password">
  @if (data.loading) {
    <div class="font-extrabold text-2xl text-center">
      {{ data.message }}
    </div>
    <div class="mt-4 mx-auto">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  } @else {
    <div class="font-extrabold text-2xl text-center">Finalizado</div>
  }
</mat-card>
